// src/utils/excelUtils.js
export const exportToExcel = async (data, fileName) => {
  const XLSX = await import("xlsx");
  // Convert data to worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  // Write the workbook to file
  XLSX.writeFile(workbook, fileName);
};
